import {
  InputProps as HeadlessInputProps,
  Input as HeadlessInput,
} from "@headlessui/react";
import React, { RefObject, FC } from "react";

export type HiddenInputProps = HeadlessInputProps & {
  type: "hidden";
  ref?: RefObject<HTMLInputElement>;
};
/**
 * DO NOT USE!
 * USE THE FACADE COMPONENT `Input` INSTEAD.
 */
export const HiddenInput: FC<HiddenInputProps> = (props) => (
  <HeadlessInput {...props} />
);
